import React from 'react'
import { connect } from 'react-redux';
import styles from './ScanEntry.module.css'
import { getDateMDYYYY } from '_helpers';
import { ViewButton } from '_components';
import { scanService } from '_services';

class PatientHomeScanEntry extends React.Component {

    openScan(scanId) {
        if (this.props.entry.filename.endsWith('.pdf')) {
            let newWindow = window.open('/loading.html');
            newWindow.onload = () => {
                scanService.raw(scanId)
                    .then(response => response.blob())
                    .then(blobby => {
                        let objectUrl = window.URL.createObjectURL(blobby);
                        newWindow.location = objectUrl;
                    });
            }

        } else {

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            scanService.raw(scanId)
                .then(response => response.blob())
                .then(blobby => {
                    let url = window.URL.createObjectURL(blobby);
                    a.href = url;
                    a.download = this.props.entry.filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
        }
    }

    render() {
        var bold = this.props.entry.status >= 1 && this.props.entry.status <= 3 ? styles.bold : '';
        return (
            <div className={styles.entry_wrapper + ' ' + bold}>
                <div className={styles.spacer}><ViewButton size='extra-small' onClick={() => this.openScan(this.props.entry.id)} /></div>
                <div className={styles.date}>{getDateMDYYYY(this.props.entry.date)}</div>
                <div className={styles.type}>{this.props.entry.type}</div>
                <div className={styles.notes} title={this.props.entry.notes}>{this.props.entry.notes}</div>
                <div className={styles.user}>{this.props.entry.user}</div>
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        entry: state.entities.scans[ownprops.id]
    };
}

const connectedPatientHomeScanEntry = connect(mapStateToProps)(PatientHomeScanEntry);
export { connectedPatientHomeScanEntry as PatientHomeScanEntry };